var heading8 = {
  size: 'p-8',
  weight: 'bold',
  tracking: 'narrow',
  leading: 'dense' // 0.75rem // 12px
};
var heading16 = {
  size: 'p-16',
  weight: 'bold',
  leading: 'normal',
  // 1.5rem // 24px
  tracking: 'normal'
};
var heading18 = {
  size: 'p-18',
  weight: 'bold',
  leading: 'normal',
  // 1.5rem // 24px
  tracking: 'normal'
};
var heading20 = {
  size: 'p-20',
  weight: 'bold',
  leading: 'normal',
  // 1.5rem // 24px
  tracking: 'normal'
};
var heading24 = {
  size: 'p-24',
  weight: 'bold',
  leading: 'relaxed',
  // 2rem // 32px
  tracking: 'narrow'
};
var heading28 = {
  size: 'p-28',
  weight: 'bold',
  leading: 'relaxed',
  // 2rem // 32px
  tracking: 'narrow'
};
var heading32 = {
  size: 'p-32',
  weight: 'bold',
  leading: 'loose',
  // 2.5rem // 40px
  tracking: 'narrow'
};
var heading36 = {
  size: 'p-36',
  weight: 'bold',
  leading: 'loose',
  // 2.5rem // 40px
  tracking: 'narrow'
};
var heading42 = {
  size: 'p-42',
  weight: 'bold',
  leading: 'loosest',
  // 3rem // 48px
  tracking: 'narrow'
};

/** News */
var newsHeading16 = {
  size: 'p-16',
  weight: 'bold',
  leading: 'normal',
  // 1.5rem // 24px
  tracking: 'normal',
  fontFamily: 'serif'
};
var newsHeading18 = {
  size: 'p-18',
  weight: 'bold',
  leading: 'normal',
  // 1.5rem // 24px
  tracking: 'normal',
  fontFamily: 'serif'
};
var newsHeading20 = {
  size: 'p-20',
  weight: 'bold',
  leading: 'normal',
  // 1.5rem // 24px
  tracking: 'normal',
  fontFamily: 'serif'
};
var newsHeading24 = {
  size: 'p-24',
  weight: 'bold',
  leading: 'relaxed',
  // 2rem // 32px
  tracking: 'narrow'
};
var newsHeading28 = {
  size: 'p-28',
  weight: 'bold',
  leading: 'relaxed',
  // 2rem // 32px
  tracking: 'narrow',
  fontFamily: 'serif'
};
var newsHeading32 = {
  size: 'p-32',
  weight: 'bold',
  leading: 'loose',
  // 2.5rem // 40px
  tracking: 'narrow',
  fontFamily: 'serif'
};
var newsHeading36 = {
  size: 'p-36',
  weight: 'bold',
  leading: 'loose',
  // 2.5rem // 40px
  tracking: 'narrow',
  fontFamily: 'serif'
};
var newsHeading42 = {
  size: 'p-42',
  weight: 'bold',
  leading: 'loosest',
  // 3rem // 48px
  tracking: 'narrow',
  fontFamily: 'serif'
};
var headingVariants = {
  'heading-8': heading8,
  'heading-16': heading16,
  'heading-18': heading18,
  'heading-20': heading20,
  'heading-24': heading24,
  'heading-28': heading28,
  'heading-32': heading32,
  'heading-36': heading36,
  'heading-42': heading42,
  'news-heading-16': newsHeading16,
  'news-heading-18': newsHeading18,
  'news-heading-20': newsHeading20,
  'news-heading-24': newsHeading24,
  'news-heading-28': newsHeading28,
  'news-heading-32': newsHeading32,
  'news-heading-36': newsHeading36,
  'news-heading-42': newsHeading42
};

export { headingVariants };
//# sourceMappingURL=heading.variants.esm.js.map
